import { render, staticRenderFns } from "./AIGodownChat.vue?vue&type=template&id=050c799a&scoped=true"
import script from "./AIGodownChat.vue?vue&type=script&lang=js"
export * from "./AIGodownChat.vue?vue&type=script&lang=js"
import style0 from "./AIGodownChat.vue?vue&type=style&index=0&id=050c799a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c799a",
  null
  
)

export default component.exports